<template>
  <div class="cartUpsell">
    <div v-if="data.message" class="cartUpsell__msg">{{ data.message }}</div>
    <div class="cart_upsell-wrapper">
      <ImageField
        class="cartUpsell__image"
        :obj="{ url: data.image, alt: 'upsell image', width: 228, height: 285 }"
        width-param="width"
        sizes="300px"
      />
      <div class="cart_upsell-inner">
        <div class="cartUpsell__info">
          <a
            :href="`/products/` + data.handle + '?variant=' + data.variantId"
            class="cartUpsell__title"
            :aria-label="`Product title ${data.title}`"
            >{{ data.title }}</a
          >
          <div v-if="data.product.id" class="cartUpsell__review-wrapper">
            <div
              class="yotpo-widget-instance"
              data-yotpo-instance-id="498880"
              :data-yotpo-product-id="data.product.id"
            ></div>
          </div>
          <!-- <span class="cartUpsell__variantTitle">{{ data.variantTitle }}</span> -->
        </div>
        <div class="cartUpsell__bottom">
          <button
            data-stio-gtm-id="CART DRAWER UPSELL: ATC"
            :data-upsell-handle="data.handle"
            :data-upsell-variant-id="data.variantId"
            v-if="data.available"
            class="btn cartUpsell--btn"
            @click.prevent="toggleAddItem"
            :aria-label="`Add product ${data.title} to cart`"
          >
            ADD TO CART
          </button>
          <button v-else disabled class="btn cartUpsell__-btn">OUT OF STOCK</button>
          <div class="cartUpsell__price-wrapper">
            <span :class="['cartUpsell__price', { '--discount': data.compareAtPrice > data.price }]">{{
              formatPrice(data.price)
            }}</span>
            <span v-if="data.compareAtPrice > data.price" class="cartUpsell__comparePrice">{{
              formatPrice(data.compareAtPrice)
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import ImageField from '../../global/image.vue';

  const props = defineProps({
    data: {
      type: Object,
      default: {},
    },
  });

  const formatPrice = (price) => {
    return window.formattedPrice(price);
  };

  const toggleAddItem = () => {
    window.toggleDrawer(true, 'EditCartItem', {
      drawerHeading: 'Select Options',
      productData: props.data.product,
      variantId: props.data.variantId,
      isCartUpsell: true,
    });
  };
</script>
